import { capsulesOverlap } from './geometry.js';
/** Extra clearance left between the capsules so they do not re-overlap from rounding. */
export const SEPARATION_MARGIN = 0.02;
/** Pushes needed so the two capsules stop overlapping, or null when they do not overlap. */
export function separateCapsules(a, b) {
    if (!capsulesOverlap(a.capsule, b.capsule))
        return null;
    const dx = b.capsule.base.x - a.capsule.base.x;
    const dz = b.capsule.base.z - a.capsule.base.z;
    const dist = Math.hypot(dx, dz);
    // Coincident axes: pick a fixed direction so the result stays deterministic.
    const nx = dist < 1e-6 ? 1 : dx / dist;
    const nz = dist < 1e-6 ? 0 : dz / dist;
    const push = a.capsule.radius + b.capsule.radius - dist + SEPARATION_MARGIN;
    const total = a.weight + b.weight;
    const shareA = total > 0 ? b.weight / total : 0.5;
    const shareB = 1 - shareA;
    // `+ 0` folds negative zero into zero so the state stays identical across JSON round-trips.
    return {
        a: { x: -nx * push * shareA + 0, y: 0, z: -nz * push * shareA + 0 },
        b: { x: nx * push * shareB + 0, y: 0, z: nz * push * shareB + 0 },
    };
}
//# sourceMappingURL=separation.js.map